export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        radio('filter-and-search-changed').subscribe(updateMapLink);
        function updateMapLink(result) {
            ele.href = `${ele.protocol}//${ele.host}/${result.mapUrl}`;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/mapLink.js